import { render } from "./ToastWrapper.vue?vue&type=template&id=ca210e74"
import script from "./ToastWrapper.vue?vue&type=script&lang=js"
export * from "./ToastWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__